import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'disability-status',
    component: () => import(/* webpackChunkName: "base-layout" */ '@/layouts/BaseLayout.vue'),
    children: [
        {
            path: '',
            name: 'disability-status-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [                    
                    {                           
                        transKey: 'breadcrumbs.disability-status-index',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "disability-status-index" */ '@/modules/configurations/catalogs/disability-status/views/Index.vue')
        },
        {
            path: 'create',
            name: 'disability-status-create',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {   
                        route: {
                            name: 'disability-status-index',
                            params: {}
                        },
                        transKey: 'breadcrumbs.disability-status-index',
                        isActive: false
                    },
                    {                           
                        transKey: 'breadcrumbs.disability-status-create',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "disability-status-create" */ '@/modules/configurations/catalogs/disability-status/views/Create.vue')
        },
        {
            path: 'edit/:id',
            name: 'disability-status-edit',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {   
                        route: {
                            name: 'disability-status-index',
                            params: {}
                        },
                        transKey: 'breadcrumbs.disability-status-index',
                        isActive: false
                    },
                    {                           
                        transKey: 'breadcrumbs.disability-status-edit',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "disability-status-edit" */ '@/modules/configurations/catalogs/disability-status/views/Edit.vue')
        }
    ]
}